import { Routes, Route, Navigate } from 'react-router-dom'
import AnalyticsPage from './pages/AnalyticsPage'
import { Layout } from './components/Layout'
import { OverviewPage } from './pages/OverviewPage'
import { Dashboard } from './pages/Dashboard'
import { SeedDetail } from './pages/SeedDetail'
import { ClientsPage } from './pages/ClientsPage'
import { ClientDetailPage } from './pages/ClientDetailPage'
import { SharesPage } from './pages/SharesPage'
import { CreateSharePage } from './pages/CreateSharePage'
import { ShareDetailPage } from './pages/ShareDetailPage'
import { D1BrowserPage } from './pages/D1BrowserPage'
import { R2BrowserPage } from './pages/R2BrowserPage'
import { GeoKeysPage } from './pages/GeoKeysPage'
import { GfbundlesPage } from './pages/GfbundlesPage'
import { AuditPage } from './pages/AuditPage'
import { CleanupPage } from './pages/CleanupPage'
import { SettingsPage } from './pages/SettingsPage'
import { GuidesPage } from './pages/GuidesPage'
import { GuideSeedPage } from './pages/GuideSeedPage'
import { GuidePreviewPage } from './pages/GuidePreviewPage'
import { NotFound } from './pages/NotFound'

export default function App() {
  return (
    <Routes>
      <Route path="/" element={<Layout />}>
        <Route index element={<OverviewPage />} />
        <Route path="seeds" element={<Dashboard />} />
        <Route path="seeds/:name" element={<SeedDetail />} />
        <Route path="shares" element={<SharesPage />} />
        <Route path="shares/new" element={<CreateSharePage />} />
        <Route path="shares/:id" element={<ShareDetailPage />} />
        <Route path="gfbundles" element={<GfbundlesPage />} />
        <Route path="users" element={<ClientsPage />} />
        <Route path="users/:email" element={<ClientDetailPage />} />
        <Route path="clients" element={<Navigate to="/users" replace />} />
        <Route path="admin" element={<Navigate to="/users" replace />} />
        <Route path="analytics" element={<AnalyticsPage />} />
        <Route path="audit" element={<AuditPage />} />
        <Route path="guides" element={<GuidesPage />} />
        <Route path="guides/:seed" element={<GuideSeedPage />} />
        {/* The breadcrumb on a preview links back to each ancestor segment, so
            this path is reachable from every guide page. It lands on the seed's
            version list with that version opened. */}
        <Route path="guides/:seed/:version" element={<GuideSeedPage />} />
        <Route path="guides/:seed/:version/:revision" element={<GuidePreviewPage />} />
        <Route path="guides/:seed/:version/:revision/:guide" element={<GuidePreviewPage />} />
        <Route path="geo" element={<GeoKeysPage />} />
        <Route path="d1" element={<D1BrowserPage />} />
        <Route path="r2" element={<R2BrowserPage />} />
        <Route path="cleanup" element={<CleanupPage />} />
        <Route path="settings" element={<SettingsPage />} />
        <Route path="*" element={<NotFound />} />
      </Route>
    </Routes>
  )
}
